import React from 'react';
import { Popconfirm, PopconfirmProps } from 'components';
import DocumentsContext from '../DocumentsContext';

interface ConfirmArchiveProps extends Partial<PopconfirmProps> {
  id: string;
  open: boolean;
  onOpenChange: (visible: boolean) => void;
}

const ConfirmArchive: React.FC<ConfirmArchiveProps> = ({
  id,
  open,
  onOpenChange,
  ...props
}) => {
  const { archive } = React.useContext(DocumentsContext);

  const handleConfirm = () => {
    archive(id);
    onOpenChange(false);
  };

  return (
    <Popconfirm
      title="Are you sure you’d like to archive this document?"
      placement="left"
      width={250}
      overlayStyle={{ zIndex: 2000 }}
      getPopupContainer={el => el.parentElement}
      onOpenChange={onOpenChange}
      onCancel={() => onOpenChange(false)}
      onConfirm={handleConfirm}
      cancelText="No"
      okText="Yes"
      open={open}
      {...props}
    />
  );
};

export default ConfirmArchive;
